module.exports = __webpack_public_path__ + "img/lottery_active.6802ba60.png";